import type { CityConfig } from "../city-template/types";

export const norfolkVaConfig: CityConfig = {
  city: "Norfolk",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "norfolk-va",
  route: "/cities/norfolk-va",
  title: "Emergency Passport Norfolk, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Norfolk, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Naval Station Norfolk, military families, and Hampton Roads travelers. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Norfolk, VA",
  heroSubtitle: "Passport expired before deployment or PCS orders? Need an emergency passport fast? We help Norfolk and Hampton Roads travelers — including Navy personnel stationed at Naval Station Norfolk, the world's largest naval base — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20photograph%20of%20Norfolk%20Virginia%20skyline%20at%20golden%20hour%20with%20the%20Elizabeth%20River%20waterfront%2C%20modern%20downtown%20buildings%2C%20the%20USS%20Wisconsin%20battleship%20at%20the%20waterfront%2C%20navy%20ships%20docked%20at%20Naval%20Station%20Norfolk%20in%20the%20distance%2C%20warm%20amber%20and%20orange%20sunset%20colors%20reflecting%20on%20the%20water%2C%20clean%20professional%20cityscape%20photography%20with%20vivid%20warm%20colors%20and%20sharp%20detail%2C%20lush%20green%20trees%20along%20the%20riverfront%2C%20no%20text%20or%20signs%20visible&width=1800&height=700&seq=norfolk-va-hero-001&orientation=landscape",
  heroImageAlt: "Norfolk Virginia skyline at sunset along the Elizabeth River waterfront with naval ships",
  geoPosition: "36.8508;-76.2859",
  geoPlacename: "Norfolk, Virginia",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 200 miles from Norfolk via I-64 and I-95",
  },
  nearbyCitiesZips: [
    { name: "Norfolk", zips: "23501–23523" },
    { name: "Virginia Beach", zips: "23450–23479" },
    { name: "Chesapeake", zips: "23320–23328" },
    { name: "Portsmouth", zips: "23701–23709" },
    { name: "Suffolk", zips: "23432–23439" },
    { name: "Hampton", zips: "23661–23669" },
    { name: "Newport News", zips: "23601–23609" },
    { name: "Williamsburg", zips: "23185, 23188" },
    { name: "Richmond", zips: "23219–23242" },
    { name: "Ghent", zips: "23507, 23517" },
    { name: "Ocean View", zips: "23503" },
    { name: "Larchmont", zips: "23508" },
    { name: "East Beach", zips: "23518" },
    { name: "Freemason", zips: "23510" },
    { name: "Downtown Norfolk", zips: "23510" },
    { name: "Norfolk Naval Shipyard", zips: "23709" },
    { name: "Little Creek", zips: "23518" },
    { name: "Wards Corner", zips: "23505" },
    { name: "Military Circle", zips: "23502" },
    { name: "Lamberts Point", zips: "23504" },
    { name: "Charlottesville", zips: "22901–22911" },
    { name: "Roanoke", zips: "24001–24020" },
    { name: "Fredericksburg", zips: "22401–22408" },
    { name: "Arlington", zips: "22201–22217" },
    { name: "Alexandria", zips: "22301–22315" },
    { name: "McLean", zips: "22101, 22102" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Norfolk departures and military deployments" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Hampton Roads Hub", desc: "Serving Norfolk, Virginia Beach, Chesapeake, and all of Hampton Roads" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Virginia Beach passport services", route: "/cities/virginia-beach" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Norfolk remotely via secure courier. We do not have a walk-in office in Norfolk — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Hampton Roads travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Norfolk and the Hampton Roads region including Virginia Beach, Chesapeake, Portsmouth, Suffolk, Hampton, and Newport News",
  serviceAreaIntro: "From Naval Station Norfolk to Ghent, from Ocean View to East Beach, from downtown to Wards Corner — Fast Passport Center serves the entire Hampton Roads region. We regularly help Navy personnel, Marine families, and Coast Guard members, plus civilian travelers and business professionals, get their passports fast.",
  nearbyCitiesIntro: "We serve all Norfolk neighborhoods and the surrounding Hampton Roads region including Virginia Beach, Chesapeake, Portsmouth, Suffolk, Hampton, Newport News, Williamsburg, and extending to Richmond, Charlottesville, and Fredericksburg. If you are anywhere in the Hampton Roads metropolitan area, we have you covered.",
  howItWorksIntro: "Most Norfolk travelers complete everything online and ship documents overnight. No need to drive to Washington, DC or wait in line at the regional agency.",
  mistakesIntro: "Norfolk travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Norfolk and Hampton Roads travelers trust us when their deployment, vacation, or business trip is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Norfolk? Here are the most common ones we hear from Hampton Roads travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Norfolk international flights and military deployments.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer R.",
      location: "Naval Station Norfolk, VA",
      rating: 5,
      text: "My husband got last-minute PCS orders to Okinawa. Fast Passport Center had our whole family's passports ready in 2 days. They understood the Navy urgency and the whole process was seamless. We never had to leave Hampton Roads.",
      service: "Emergency Passport",
    },
    {
      name: "Marcus D.",
      location: "Chesapeake, VA",
      rating: 5,
      text: "Booked a Mediterranean cruise out of Norfolk and realized my passport was expired 3 weeks before departure. Fast Passport Center had it renewed in 4 days. I shipped from the Norfolk UPS Store and never worried once.",
      service: "Passport Renewal",
    },
    {
      name: "Amanda L.",
      location: "Norfolk, VA",
      rating: 5,
      text: "First passports for my three kids before our family trip to Japan. Fast Passport Center walked us through the military family requirements and had everything ready in 5 days. The dedicated agent was a lifesaver.",
      service: "Child Passport",
    },
    {
      name: "Robert T.",
      location: "Ghent, Norfolk, VA",
      rating: 5,
      text: "Lost my passport the night before a business trip to Germany. Fast Passport Center had a replacement in my hands in 28 hours. Absolutely incredible service for anyone in the Norfolk area.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "norfolk-1",
      name: "Norfolk Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "555 E Main St",
      city: "Norfolk",
      state: "VA",
      zip: "23510",
      phone: "(757) 625-3161",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Norfolk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Norfolk facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "norfolk-2",
      name: "Virginia Beach Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1355 Laskin Rd",
      city: "Virginia Beach",
      state: "VA",
      zip: "23451",
      phone: "(757) 425-2191",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Virginia Beach, approximately 15 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Hampton Roads facility serving Virginia Beach and Norfolk. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "norfolk-3",
      name: "Chesapeake Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1400 Plaza Dr",
      city: "Chesapeake",
      state: "VA",
      zip: "23320",
      phone: "(757) 547-3461",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Western Norfolk, Chesapeake city center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chesapeake and western Norfolk. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "norfolk-4",
      name: "Portsmouth Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 Crawford St",
      city: "Portsmouth",
      state: "VA",
      zip: "23704",
      phone: "(757) 397-0521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Portsmouth, approximately 10 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Portsmouth and western Hampton Roads. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "norfolk-5",
      name: "Hampton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Eaton St",
      city: "Hampton",
      state: "VA",
      zip: "23669",
      phone: "(757) 722-2491",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hampton, approximately 25 miles north via I-64",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hampton, Langley AFB, and northern Peninsula area. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "norfolk-6",
      name: "Norfolk Naval Shipyard Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "900 B St",
      city: "Portsmouth",
      state: "VA",
      zip: "23709",
      phone: "(757) 397-5521",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Naval Shipyard area, Portsmouth",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Navy personnel and shipyard workers. Limited hours — call ahead for appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5 hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Norfolk photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hampton Roads acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Norfolk applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hampton Roads families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Norfolk travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Norfolk." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Norfolk address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Norfolk before international travel or deployment?", a: "Yes. Fast Passport Center provides emergency passport services in Norfolk for travelers with urgent international flights and military personnel with deployment orders. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5 hour drive to Washington, DC." },
    { q: "How fast can I renew my passport in Norfolk?", a: "Fast Passport Center offers fast passport renewal in Norfolk in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Norfolk?", a: "The nearest regional passport agency to Norfolk is the Washington Passport Agency, approximately 200 miles away via I-64 and I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Norfolk without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Norfolk?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency — approximately 3.5 hours from Norfolk — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Hampton Roads residents." },
    { q: "Can I expedite a child passport in Norfolk?", a: "Yes. Fast Passport Center expedites child passports in Norfolk for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Hampton Roads families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Norfolk with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Norfolk?", a: "With Fast Passport Center's emergency courier service, Norfolk travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Norfolk?", a: "Popular options include the Norfolk Main Post Office (23510), Virginia Beach Main Post Office (23451), Chesapeake Main Post Office (23320), Portsmouth Main Post Office (23704), Hampton Main Post Office (23669), and Norfolk Naval Shipyard Post Office (23709). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Norfolk?", a: "Same-day passports are only available at the Washington Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 3.5 hour drive to DC." },
    { q: "What if I live at Naval Station Norfolk or in military housing?", a: "We serve all military personnel and families stationed at Naval Station Norfolk, JEB Little Creek, and Naval Air Station Oceana. Our overnight shipping labels work from any UPS location, including the on-base post office. We understand military orders and deployment urgency, and can process passports as fast as 24–48 hours." },
    { q: "How much does expedited passport service cost in Norfolk?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help military personnel in Norfolk?", a: "Absolutely. We regularly assist Navy, Marine, and Coast Guard personnel stationed at Naval Station Norfolk, the world's largest naval base. We understand PCS orders, deployment urgency, and military family needs. We can process passports as fast as 24–48 hours for orders and emergency leave." },
    { q: "Do you help with passport photos in Norfolk?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and Walmart locations in Norfolk, Virginia Beach, and Chesapeake offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Norfolk?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Norfolk?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Hampton Roads families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Norfolk", address: "850 W 21st St, Norfolk, VA 23517", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Norfolk", address: "3000 E Ocean View Ave, Norfolk, VA 23518", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Norfolk", address: "7525 Tidewater Dr, Norfolk, VA 23505", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Norfolk", address: "5900 E Virginia Beach Blvd, Norfolk, VA 23502", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS Pharmacy — Virginia Beach", address: "2113 General Booth Blvd, Virginia Beach, VA 23454", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Chesapeake", address: "2001 S Military Hwy, Chesapeake, VA 23320", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Chesapeake", address: "2448 Chesapeake Square Ring Rd, Chesapeake, VA 23321", hours: "Mon–Sun: 6AM–11PM" },
    { name: "FedEx Office — Virginia Beach", address: "4554 Virginia Beach Blvd, Virginia Beach, VA 23462", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Norfolk",
      address: "850 Widgeon Rd, Norfolk, VA 23513",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Virginia Beach",
      address: "1712 Princess Anne Rd, Virginia Beach, VA 23456",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Chesapeake",
      address: "803 Corridor Ct, Chesapeake, VA 23320",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Chesapeake and western Norfolk residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Virginia DMV — Hampton",
      address: "8109 Roanoke Ave, Hampton, VA 23661",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Hampton, Newport News, and Peninsula area. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Located in Norfolk, 8 miles from downtown Norfolk",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "The primary airport for Hampton Roads. Direct flights to major domestic destinations and international connections. Serves Norfolk, Virginia Beach, and the entire Hampton Roads region.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: true,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "100 miles northwest of Norfolk",
      address: "1 Richard E Byrd Terminal Dr, Richmond, VA 23250",
      note: "Alternative airport for domestic flights. Accessible via I-64.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "DCA",
      name: "Reagan National Airport",
      distance: "200 miles north of Norfolk",
      address: "2401 Smith Ave, Arlington, VA 22202",
      note: "Major international hub for long-haul flights to Europe and Asia. Accessible via I-64 and I-95.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Virginia Department of Health Division of Vital Records in Richmond — order certified birth and death certificates for Norfolk and Hampton Roads residents online, by mail, or in person.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Norfolk Circuit Court Clerk — certified marriage licenses for name change passport applications.", url: "https://www.norfolk.gov/" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Norfolk Circuit Court — certified divorce decrees supporting passport name change.", url: "https://www.vacourts.gov/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "Order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};